import { createAction } from 'typesafe-actions';

import { LoadingActionType } from './actionTypes';
import type { Resource } from './types';

export const setIsLoadingAction = createAction(
  LoadingActionType.SET_IS_LOADING
)<[Resource, boolean]>();
